import 'component/css/new-cust.css';
import React from 'react';

import API from 'service/api';
import Util, { Data } from 'service/util';

import DatePicker from 'react-datepicker';
import ContactGroupEditor from 'component/ContactGroupEditor';
import ServiceWeekdayPicker from 'component/service/ServiceWeekdayPicker';

import LocationSelect from 'component/dropdown/LocationSelect';
import PreferredLanguageDropdown from 'component/dropdown/PreferredLanguageDropdown';

function getKey(p)
{
  return `${p.company}/${p.srv_dis}${p.srv_loc}:${p.cd_plan}${p.vh_type}`;
}

class NewCustomerPanel extends React.Component
{
  constructor(props)
  {
    super(props);
    let defObj = {
      company: Data.company[0].cd,
      srv_dis: Data.location[0].srv_dis,
      srv_loc: Data.location[0].srv_loc,
      cd_plan: Data.plan[0],
      vh_type: Data.vtype[0].id,
      worker: Data.defaultWorkerId,
    };

    this.state = {
      customer: {
        display_name: '',
        contacts: [],
        lang: 'zh-HK',
        is_mobill: false,
        is_rtn_envelope: false,
        is_print_bill: true,
      },
      vehicle: {
        cd_license: props.license||'',
        owner_id: -1,
        vh_type: 1,
        source: 0,
        color: '',
        brand: '',
        model: '',
        remarks: '',
      },
      service: {
        company: defObj.company,
        srv_plan: defObj.cd_plan,
        vh_type: defObj.vh_type,
        start_dtm: new Date(),
        end_dtm: null,
        srv_dis: defObj.srv_dis,
        srv_loc: defObj.srv_loc,
        srv_floor: '',
        srv_psn: '',
        fee: Data.price[getKey(defObj)],
        rotation: '',
        extra_fee: 0,
        worker: defObj.worker,
        weekday1: 0,
        weekday2: 0,
        weekday3: 0,
        waxing: true
      },
      new_cust_err: '',
    };

    this.setLanguage    = this.setLanguage.bind(this);
    this.setLocation    = this.setLocation.bind(this);
    this.setDisplayName = this.setDisplayName.bind(this);
    this.setLicense     = this.setLicense.bind(this);
    this.setVehicleType = this.setVehicleType.bind(this);
    this.setServicePlan = this.setServicePlan.bind(this);
    this.setWeekdays    = this.setWeekdays.bind(this);
    this.setEffect      = this.setStartDate.bind(this);
    this.submitCreate   = this.submitCreate.bind(this);

  } // constructor

  componentDidUpdate(prevProps)
  {
    if (this.props.license != prevProps.license)
    {
      this._setVehicle('cd_license', this.props.license);
    }
  }

  submitCreate(e)
  {
    e.target.disable = true;

    let { customer, vehicle, service } = this.state;
    API.newCustomer(customer, vehicle, service).then( resp => {
      if (resp.success)
      {
        this.props.onCreated( resp.msg );
      } else {
        this.setState({ new_cust_err: resp.msg });
      }
      e.target.disable = false;
    });
  }

  //---
  _setCust(key, value) {
    this.state.customer[key]= value;
    this.setState({customer: this.state.customer});
  }
  _setVehicle(key, value) {
    this.state.vehicle[key] = value;
    this.setState({vehicle: this.state.vehicle});
  }
  _setService(key, value) {
    this.state.service[key] = value;
    this.setState({service: this.state.service});
  }
  setCompany(company)
  {
    let v = this.state.vehicle;
    let s = this.state.service;
    s.company = company;
    let key = getKey({ company: s.company, srv_dis: s.srv_dis, srv_loc: s.srv_loc, cd_plan: s.srv_plan, vh_type: v.vh_type });
    s.fee = Data.price[key]||0;
    this.setState({service: s});
  }
  setDisplayName(name) { this._setCust('display_name', name); }
  setLanguage(value)   { this._setCust('lang', value); }
  setLicense(license)  { this._setVehicle('cd_license', license); }
  setVehicleType(type)
  {
    let v = this.state.vehicle;
    let s = this.state.service;
    v.vh_type = parseInt(type,10);
    let key = getKey({ company: s.company, srv_dis: s.srv_dis, srv_loc: s.srv_loc, cd_plan: s.srv_plan, vh_type: v.vh_type });
    s.fee = Data.price[key]||0;
    this.setState({vehicle: v, service: s});
  }
  setMontlyBill(value)     { this._setCust('is_mobill', value); }
  setReturnEnvelope(value) { this._setCust('is_rtn_envelope', value); }
  setPrintBill(value)      { this._setCust('is_print_bill', value); }

  setCustSource(source)    { this._setVehicle('source', parseInt(source,10)); }
  setColor(color)  { this._setVehicle('color', color); }
  setBrand(brand)  { this._setVehicle('brand', brand); }
  setModel(model)  { this._setVehicle('model', model); }

  setServicePlan(plan)
  {
    let v = this.state.vehicle;
    let s = this.state.service;
    s.srv_plan = plan;
    switch (plan) {
      case 'A':
        s.weekday1 = 0;
        s.weekday2 = 0;
        s.weekday3 = 0;
        s.waxing   = true;
        break;
      case 'B':
        s.waxing   = true;
        break;
      case 'C':
        s.weekday2 = 0;
        s.weekday3 = 0;
        s.waxing   = false;
        break;
    }
    let key = getKey({ company: s.company, srv_dis: s.srv_dis, srv_loc: s.srv_loc, cd_plan: s.srv_plan, vh_type: v.vh_type });
    s.fee = Data.price[key]||0;
    this.setState({service: s});
  }
  setWeekdays(d1, d2, d3)
  {
    this.state.service.weekday1 = d1;
    this.state.service.weekday2 = d2;
    this.state.service.weekday3 = d3;
    this.setState({service: this.state.service});
  }
  setLocation(dist, loc)
  {
    let v = this.state.vehicle;
    let s = this.state.service;
    s.srv_dis = dist;
    s.srv_loc = loc;
    s.worker  = Data.defaultWorkerId;
    let key = getKey({ company: s.company, srv_dis: s.srv_dis, srv_loc: s.srv_loc, cd_plan: s.srv_plan, vh_type: v.vh_type });
    s.fee = Data.price[key]||0;
    this.setState({service: s});
  }
  setStartDate(date)   { this._setService('start_dtm', Util.DSTR(date)); }
  setFloor(floor)      { this._setService('srv_floor', floor); }
  setParkingSpace(psn) { this._setService('srv_psn', psn); }
  setFee(fee)          { this._setService('fee', fee); }
  setWorker(id)        { this._setService('worker', id); }
  setRotation(value)   { this._setService('rotation', value); }
  setExtraFee(value)   { this._setService('extra_fee', value); }
  setWaxing(value)     { this._setService('waxing', value); }

  render()
  {
    const c = this.state.customer;
    const v = this.state.vehicle;
    const s = this.state.service;

    return (
      <div className="box new-cust">
        <h4 className="box-head">新客戶</h4>
        <div className="box-body">
          <div className="split">
            <section className="cust-info">
              <label className="field">
                <strong>客戶名稱</strong>
                <input type="text" placeholder="賬單中顯示的名稱" value={c.display_name}
                       onChange={e=>this.setDisplayName(e.target.value)} />
              </label>
              <label className="field">
                <strong>車牌號碼</strong>
                <input type="text" placeholder="車牌號碼" value={v.cd_license}
                       onChange={e=>this.setLicense(e.target.value.toUpperCase())} />
              </label>
              <div className="split-3">
                <label className="field">
                  <strong>服務計劃</strong>
                  <select className="nc-plan" value={s.srv_plan}
                          onChange={e=>this.setServicePlan(e.target.value)}>
                    { Data.plan.map(p =>
                      <option key={`plan-${p}`} value={p}>{p}</option>
                    )}
                  </select>
                </label>
                <label className="field">
                  <strong>車種</strong>
                  <select className="nc-vhtype" value={v.vh_type}
                          onChange={e=>this.setVehicleType(e.target.value)}>
                    { Data.vtype.map(t =>
                      <option key={`vt-${t.id}`} value={t.id}>{t.id} - {t.desc}</option>
                    )}
                  </select>
                </label>
                <label className="field">
                  <strong>客源</strong>
                  <select className="nc-vhtype" value={c.source}
                          onChange={e=>this.setCustSource(e.target.value)}>
                    <option value={0}></option>
                    <option value={1}>傳單</option>
                    <option value={2}>工人介紹</option>
                    <option value={3}>優悠家居</option>
                    <option value={4}>合拼</option>
                  </select>
                </label>
              </div>
              <div className="split-3">
                <label className="field">
                  <strong>顏色</strong>
                  <input type="text" value={v.color}
                         onChange={e=>this.setColor(e.target.value)} />
                </label>
                <label className="field">
                  <strong>品牌</strong>
                  <input type="text" value={v.brand} list="ls-brand"
                         onChange={e=>this.setBrand(e.target.value)} />
                  <datalist id="ls-brand">
                    { Data.brand.map(b =>
                      <option key={`brand-${b.name_en}`} value={b.name_en}>{b.name_zh}</option>
                    )}
                  </datalist>
                </label>
                <label className="field">
                  <strong>型號</strong>
                  <input type="text" value={v.model}
                         onChange={e=>this.setModel(e.target.value.toUpperCase())}
                         onBlur={e=>this.setModel(e.target.value.trim().toUpperCase())}
                        />
                </label>
              </div>
              <div className="split-3">
                <label className="field">
                  <strong>月結</strong>
                  <input type="checkbox" checked={c.is_mobill}
                        onChange={e=>this.setMontlyBill(e.target.checked)} />
                </label>
                <label className="field">
                  <strong>回郵信封</strong>
                  <input type="checkbox" checked={c.is_rtn_envelope}
                        onChange={e=>this.setReturnEnvelope(e.target.checked)} />
                </label>
                <label className="field">
                  <strong>印收費單</strong>
                  <input type="checkbox" checked={c.is_print_bill}
                        onChange={e=>this.setPrintBill(e.target.checked)} />
                </label>
              </div>
              <label className="field">
                <strong>打蠟</strong>
                <input type="checkbox" checked={s.waxing}
                      onChange={e=>this.setWaxing(e.target.checked)} />
              </label>
              <label className="field">
                <strong>聯絡方法</strong>
                <ContactGroupEditor contacts={c.contacts} />
              </label>
              <label className="field">
                <strong>偏好語言</strong>
                <PreferredLanguageDropdown value={c.lang} onChange={this.setLanguage}/>
              </label>
            </section>
            <section className="svc-info">
              <div className="split-3">
                <label className="field">
                  <strong>公司</strong>
                  <select className="nc-company" value={s.company}
                          onChange={e=>this.setCompany(e.target.value)}>
                    { Data.company.map(com =>
                      <option key={com.cd} value={com.cd}>{com.cd} - {com.name}</option>
                    )}
                  </select>
                </label>
                <label className="field">
                  <strong>服務日</strong>
                  <ServiceWeekdayPicker plan={s.srv_plan}
                    d1={s.weekday1} d2={s.weekday2} d3={s.weekday3}
                    onChange={this.setWeekdays} />
                </label>
              </div>
              <label className="field">
                <strong>生效日期</strong>
                <DatePicker selected={ new Date(s.start_dtm) }
                  onChange={ d=>this.setStartDate(d) }
                  dateFormat="yyyy-MM-dd" />
              </label>
              <div className="x-inline-1">
                <LocationSelect labelClass="field"
                  district={s.srv_dis}
                  location={s.srv_loc}
                  onUpdate={this.setLocation}
                />
              </div>
              <label className="field">
                <strong>樓層</strong>
                <input type="text" placeholder="車輛停泊樓層" value={s.srv_floor}
                       onChange={e=>this.setFloor(e.target.value)} />
              </label>
              <label className="field">
                <strong>車位</strong>
                <input type="text" placeholder="車位號碼" value={c.srv_psn}
                       onChange={e=>this.setParkingSpace(e.target.value)} />
              </label>
              <div className="split-3">
                <label className="field">
                  <strong>月費</strong>
                  <input type="number" placeholder="價錢" value={s.fee} required
                        onChange={e=>this.setFee( parseFloat(e.target.value) )} />
                </label>
                <label className="field">
                  <strong>附加項目</strong>
                  <input type="text" placeholder="如輪抹車" value={s.rotation} required
                        onChange={e=>this.setRotation( e.target.value )} />
                </label>
                <label className="field">
                  <strong>附加費</strong>
                  <input type="number" placeholder="價錢" value={s.extra_fee} required
                        onChange={e=>this.setExtraFee( parseFloat(e.target.value) )} />
                </label>
              </div>
              <label className="field">
                <strong>負責工人</strong>
                <select value={s.worker} required
                       onChange={e=>this.setWorker( parseInt(e.target.value, 10) )}>
                  <option value={Data.defaultWorkerId}>公司預設 (ID={Data.defaultWorkerId})</option>
                  { Data.wkrloc[`${s.srv_dis}${s.srv_loc}`]?.map(w =>
                    <option key={`wkr-${w.uid}`} value={w.uid}>{w.cd} - {w.name}</option>
                  )}
                </select>
              </label>
            </section>
          </div>
          <div className="action-panel">
            <div className="error-msg">
              { this.state.new_cust_err }
            </div>
            <div>
              <button type="button" className="btn blue"
                      onClick={e=>this.submitCreate(e)}>新增</button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default NewCustomerPanel;